import PDFContent from './PDFContent'

export default PDFContent
